import { ReactNode } from 'react';
import styles from './profe-page.module.css';
import {
  Button,
  CommentsList,
  Container,
  WorksCard,
  WorksCardList,
  Notification,
} from '../../components';
import Awards, { AwardsProps } from '../templates/awards';
import { WorksCardProps } from '../../components/works-card';

export interface ProfePageProps {
  intro: {
    bg: string;
    h1: string | ReactNode;
    h2: string;
    btn: string;
  };
  info: string;
  tecnologic: {
    title: string;
    list: {
      image: string;
      name: string;
    }[];
  };
  service: {
    title: string;
    list: {
      image: string;
      title: string;
      text: string;
    }[];
  };
  devtool: {
    title: string;
    list: {
      image: string;
      name: string;
    }[];
  };
  awards: AwardsProps;
  works: WorksCardProps[];
}

export default function ProfePage({
  intro,
  info,
  tecnologic,
  service,
  devtool,
  awards,
  works,
}: ProfePageProps) {
  return (
    <div className={styles.page}>
      <section
        className={styles.intro}
        style={{ backgroundImage: `url('${intro.bg}')` }}
      >
        <Container variant="container">
          <div className={styles.intro_inner}>
            <h1 className={styles.intro_h1}>{intro.h1}</h1>
            <h2 className={styles.intro_h2}>{intro.h2}</h2>
            <div className={styles.intro_center}>
              <Button
                tag="a"
                href="/contact"
                className={styles.intro_btn}
                appearance="primary"
              >
                {intro.btn}
              </Button>
            </div>
          </div>
        </Container>
      </section>
      <div className={styles.info}>
        <Container variant="container">
          <p
            className={styles.info_text}
            dangerouslySetInnerHTML={{ __html: info }}
          />
        </Container>
      </div>

      <Awards {...awards} />

      <section className={styles.tecnologic}>
        <Container>
          <h2 className={styles.tecnologic_title}>{tecnologic.title}</h2>
          <ul className={styles.tecnologic_list}>
            {tecnologic.list.map(({ image, name }) => (
              <li className={styles.tecnologic_listItem}>
                <div className={styles.tecnologicItem}>
                  <div className={styles.tecnologicItem_paper}>
                    <img src={image} alt={name} />
                  </div>
                  <h3 className={styles.tecnologicItem_name}>{name}</h3>
                </div>
              </li>
            ))}
          </ul>
        </Container>
      </section>

      <section className={styles.service}>
        <Container>
          <h2 className={styles.service_title}>{service.title}</h2>
          <ul className={styles.service_list}>
            {service.list.map(({ image, text, title }, index) => (
              <li className={styles.service_listItem}>
                <div className={styles.serviceItem}>
                  <div className={styles.serviceItem_image}>
                    <span className={styles.serviceItem_number}>
                      {index + 1}
                    </span>
                    <img src={image} alt={title} />
                  </div>
                  <div className={styles.serviceItem_content}>
                    <h3 className={styles.serviceItem_title}>{title}</h3>
                    <p className={styles.serviceItem_text}>{text}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </Container>
      </section>
      <div className={styles.works}>
        <h2 className={styles.works_title}>RELATED WORKS</h2>
        <Container>
          <WorksCardList>
            {works.map((work, index) => (
              <WorksCard key={index} {...work} />
            ))}
          </WorksCardList>
          <div className={styles.works_btn}>
            <Button tag="a" appearance="primary" href="/works">
              See all projects
            </Button>
          </div>
        </Container>
      </div>

      <section className={styles.devtools}>
        <Container>
          <h2 className={styles.devtools_title}>{devtool.title}</h2>
          <ul className={styles.devtools_list}>
            {devtool.list.map(({ image, name }) => (
              <div className={styles.devtoolsItem}>
                <div className={styles.devtoolsItem_image}>
                  <img src={image} alt={name} />
                </div>
                <h3 className={styles.devtoolsItem_name}>{name}</h3>
              </div>
            ))}
          </ul>
        </Container>
      </section>

      <section className={styles.reviews}>
        <h2 className={styles.reviews_title}>Reviews from our clients</h2>
        <Container>
          <CommentsList className={styles.comments} />
        </Container>
      </section>

      <div className={styles.notification}>
        <Container>
          <Notification
            buttonName="Contact us"
            title="HAVE A PROJECT in mind?"
            href="/contact"
          />
        </Container>
      </div>
    </div>
  );
}
